<script lang="ts" setup>
import { onMounted, ref } from 'vue'

const emit = defineEmits<{
  (e: 'click', event: Event): void
}>()

const el = ref<HTMLElement | null>(null)

let btnWidth = 0

onMounted((): void => {
  calcBtnWidth()
})

function calcBtnWidth(): void {
  if (el.value) {
    const style = getComputedStyle(el.value)
    btnWidth += el.value.scrollWidth
    btnWidth += parseInt(style.borderLeftWidth)
    btnWidth += parseInt(style.borderRightWidth)
  }
}

function btnHovered(): void {
  if (el.value) {
    el.value.style.maxWidth = btnWidth + 'px'
  }
}

function btnLeave(): void {
  if (el.value) {
    el.value.style.maxWidth = ''
  }
}

function clicked(e: Event): void {
  emit('click', e)
}
</script>

<template>
  <button
    ref="el"
    class="btn is--tertiary is--enlarging"
    type="button"
    @click="clicked"
    @mouseleave="btnLeave"
    @mouseover="btnHovered"
  >
    <div class="btn__inner">
      <slot name="content" />
    </div>
  </button>
</template>

<style lang="scss" scoped>
button {
  padding-left: rem-calc(9);
  padding-right: rem-calc(13);
}
</style>
